import React from "react";
const TeamSection = () => <section>hey i'm TeamSection</section>;
export default TeamSection;
